<template>
    <div class="jumbotron participa-hero">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <h1 style="title font-size: 60px!important">Escribe el futuro del Talmud con nosotros</h1>
                    <h5 style="font-weight:300!important">Jabrutouch está en constante evolución y tu participación es clave para moldear el estudio online del Talmud. Ayúdanos a desarrollar nuestra nueva versión contestando una encuesta.</h5>
                    <a href="#ti-opinion" v-smooth-scroll class="btn btn-lg btn-primary px-5 my-5">
                        Participa
                    </a>
                </div>
                <div class="col-4 d-none d-sm-block">
                    <video width="100%" autoplay muted loop>
                        <source :src="require('../assets/images/Participa-02-animation-mp4.mp4')" type="video/mp4">
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
    .jumbotron.participa-hero{
        background: #3735b3;
        color: #fff;
        border-radius: 0;
    }
    .participa-hero-phone.img-fluid{
        max-width: initial;
        position: absolute;
        width: 120%;
        top: 0;
        right: 0;
    }
</style>